import React from 'react';
import SafeBrowserDownload from '../components/safeBrowserDownload';

export default function SafeBrowserDownloadPage() {
    return <SafeBrowserDownload />;
}
